import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "index-box"
};
const _hoisted_2 = {
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "filter"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("view", {
  class: "sort__down"
}, null, -1);
const _hoisted_11 = {
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: "sellout"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "part3_list_li_addr"
};
const _hoisted_16 = {
  class: "part3_list_li_title"
};
const _hoisted_17 = {
  style: {
    "margin": "5px",
    "color": "#cccccc",
    "height": "25px",
    "line-height": "25px"
  }
};
const _hoisted_18 = {
  class: "part3_list_li_kf",
  style: {
    "float": "left"
  }
};
const _hoisted_19 = {
  style: {
    "float": "right",
    "margin-right": "5px"
  }
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "clear": "both"
  }
}, null, -1);
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  class: "tagbox",
  style: {
    "padding-top": "30px"
  }
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "tagtitle"
}, "設備大小", -1);
const _hoisted_24 = ["onClick"];
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "tagtitle"
}, "設備類型", -1);
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  key: 0,
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "subtagtitle"
}, "驅動方式", -1);
const _hoisted_29 = ["onClick"];
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "subtagtitle"
}, "平臺高度", -1);
const _hoisted_31 = ["onClick"];
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "tagtitle"
}, "設備品牌", -1);
const _hoisted_33 = ["onClick"];
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "bottomH100"
}, null, -1);
const _hoisted_35 = /*#__PURE__*/_createElementVNode("button", {
  class: "comBtn"
}, "確定選擇", -1);
const _hoisted_36 = [_hoisted_35];
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "bottomH120"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_block = _resolveComponent("block");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_tabs, {
    active: $data.currentType_sb,
    "onUpdate:active": _cache[0] || (_cache[0] = $event => $data.currentType_sb = $event),
    color: "#fdd100",
    onClickTab: $options.TapCurrentSb,
    shrink: "true"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "挖掘機"
    }), _createVNode(_component_van_tab, {
      title: "其他設備"
    })]),
    _: 1
  }, 8, ["active", "onClickTab"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.areaList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "checkboxs",
      key: index,
      onClick: $event => $options.TagcheckChange_area(item.Value)
    }, [_createElementVNode("span", {
      class: _normalizeClass(["checkboxsspan", {
        is_checked: $data.checkarea.includes(item.Value)
      }])
    }, _toDisplayString(item.Value), 3)], 8, _hoisted_3);
  }), 128)), $data.currentType_sb == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.excavatorSizeslist, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "checkboxs",
      key: index,
      onClick: $event => $options.TagcheckChange_size(item.Value)
    }, [_createElementVNode("span", {
      class: _normalizeClass(["checkboxsspan", {
        is_checked: $data.checkSize.includes(item.Value)
      }])
    }, _toDisplayString(item.Value), 3)], 8, _hoisted_5);
  }), 128))])) : _createCommentVNode("", true), $data.currentType_sb == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.macTypelist, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "checkboxs",
      key: index,
      onClick: $event => $options.TagcheckChange_mac(item.Value)
    }, [_createElementVNode("span", {
      class: _normalizeClass(["checkboxsspan", {
        is_checked: $data.checkMacTypes.includes(item.Value)
      }])
    }, _toDisplayString(item.Value), 3)], 8, _hoisted_7);
  }), 128))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hotBrandlist, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "checkboxs",
      key: index,
      onClick: $event => $options.TagcheckChange_brand(item.Value)
    }, [_createElementVNode("span", {
      class: _normalizeClass(["checkboxsspan", {
        is_checked: $data.checkhotbrand.includes(item.Value)
      }])
    }, _toDisplayString(item.Value), 3)], 8, _hoisted_8);
  }), 128))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => $options.orderBy('D_PushTime')),
    class: "filter-nav"
  }, [_createElementVNode("div", {
    class: _normalizeClass($setup.currentType == 'D_PushTime' ? 'filter-nav--active' : '')
  }, "上架時間", 2), _createElementVNode("div", null, [_createElementVNode("div", {
    class: _normalizeClass(["sort__up", $setup.currentType == 'D_PushTime' && $setup.sortType == 'desc' ? 'sort__up--active' : ''])
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["sort__down", $setup.currentType == 'D_PushTime' && $setup.sortType == 'asc' ? 'sort__down--active' : ''])
  }, null, 2)])]), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => $options.orderBy('I_ViewNum')),
    class: "filter-nav"
  }, [_createElementVNode("div", {
    class: _normalizeClass($setup.currentType == 'I_ViewNum' ? 'filter-nav--active' : '')
  }, "瀏覽熱度", 2), _createElementVNode("div", null, [_createElementVNode("div", {
    class: _normalizeClass(["sort__up", $setup.currentType == 'I_ViewNum' && $setup.sortType == 'desc' ? 'sort__up--active' : ''])
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["sort__down", $setup.currentType == 'I_ViewNum' && $setup.sortType == 'asc' ? 'sort__down--active' : ''])
  }, null, 2)])]), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = $event => $setup.toggleScreen()),
    class: "filter-nav"
  }, [_createElementVNode("div", null, _toDisplayString($setup.Province == '' ? '設備所在地' : $setup.Province + $setup.City), 1), _createTextVNode(), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_withDirectives(_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[4] || (_cache[4] = $event => $setup.loading = $event),
    finished: $setup.finished,
    "finished-text": "沒有更多了",
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.MyDeviceListForShow, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "part3_list_li",
        onClick: $event => $options.goShowdetail(item),
        key: index
      }, [item.C_Tag != null && item.C_Tag != '' ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.C_Tag), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
        src: item.C_Img,
        style: {
          "width": "100%",
          "height": "140px",
          "border-radius": "3px"
        }
      }, null, 8, _hoisted_14), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_15, _toDisplayString(item.C_Province) + "-" + _toDisplayString(item.C_City), 1)]), _createElementVNode("div", _hoisted_16, _toDisplayString(item.C_ActivityTitle), 1), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, [_createTextVNode(" 查看 "), _createVNode(_component_van_icon, {
        name: "arrow"
      })]), _createElementVNode("span", _hoisted_19, [_createVNode(_component_van_icon, {
        name: "eye-o",
        size: "15px",
        style: {
          "margin": "0 2px"
        }
      }), _createTextVNode(" " + _toDisplayString(item.I_ViewNum), 1)])])], 8, _hoisted_12);
    }), 128))]), _hoisted_20]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"]), [[_vShow, !$setup.NotFind]]), $data.MyDeviceListForShow.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_van_empty, {
    description: "暫無數據"
  })])) : _createCommentVNode("", true)]), _createVNode(_component_van_popup, {
    style: {
      width: '100%'
    },
    customClass: "screen border-top",
    position: "bottom",
    show: $setup.showPicker,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $setup.showPicker = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      title: _ctx.标题,
      columns: $setup.columns,
      "columns-field-names": $setup.customFieldName,
      "confirm-button-text": "確認",
      onConfirm: $options.onConfirm,
      onCancel: $setup.onCancel,
      modelValue: $setup.selectedValues,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.selectedValues = $event)
    }, null, 8, ["title", "columns", "columns-field-names", "onConfirm", "onCancel", "modelValue"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showMore,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $setup.showMore = $event),
    position: "right",
    closeable: "",
    style: {
      width: '100%',
      height: '100%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [$data.currentType_sb == 0 ? (_openBlock(), _createBlock(_component_block, {
      key: 0
    }, {
      default: _withCtx(() => [_hoisted_23, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.m_excavatorSizeslist, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "checkboxs_c",
          key: index,
          onClick: $event => $options.More_TagcheckChange_size(item.Value)
        }, [_createElementVNode("span", {
          class: _normalizeClass(["checkboxsspan_c", {
            is_checked_c: $data.checkSize.includes(item.Value)
          }])
        }, _toDisplayString(item.Value), 3)], 8, _hoisted_24);
      }), 128))]),
      _: 1
    })) : _createCommentVNode("", true), $data.currentType_sb == 1 ? (_openBlock(), _createBlock(_component_block, {
      key: 1
    }, {
      default: _withCtx(() => [_hoisted_25, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.m_macTypelist, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "checkboxs_c",
          key: index,
          onClick: $event => $options.More_TagcheckChange_mac(item.Value)
        }, [_createElementVNode("span", {
          class: _normalizeClass(["checkboxsspan_c", {
            is_checked_c: $data.checkMacTypes.includes(item.Value)
          }])
        }, _toDisplayString(item.Value), 3)], 8, _hoisted_26);
      }), 128)), $data.isshowother ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.DrivingMode, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "checkboxs_c",
          key: index,
          onClick: $event => $options.More_TagcheckChange_mac_qd(item.Value)
        }, [_createElementVNode("span", {
          class: _normalizeClass(["checkboxsspan_c", {
            is_checked_c: $data.checkmodel.includes(item.Value)
          }])
        }, _toDisplayString(item.Value), 3)], 8, _hoisted_29);
      }), 128)), _hoisted_30, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.PlatformHigh, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "checkboxs_c",
          key: index,
          onClick: $event => $options.More_TagcheckChange_mac_gd(item.Value)
        }, [_createElementVNode("span", {
          class: _normalizeClass(["checkboxsspan_c", {
            is_checked_c: $data.checkhigh.includes(item.Value)
          }])
        }, _toDisplayString(item.Value), 3)], 8, _hoisted_31);
      }), 128))])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _hoisted_32, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.m_hotBrandlist, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "checkboxs_c",
        key: index,
        onClick: $event => $options.More_TagcheckChange_brand(item.Value)
      }, [_createElementVNode("span", {
        class: _normalizeClass(["checkboxsspan_c", {
          is_checked_c: $data.checkhotbrand.includes(item.Value)
        }])
      }, _toDisplayString(item.Value), 3)], 8, _hoisted_33);
    }), 128))]), _hoisted_34, _createElementVNode("div", {
      class: "enterprise-button",
      onClick: _cache[7] || (_cache[7] = (...args) => $options.back && $options.back(...args))
    }, _hoisted_36)]),
    _: 1
  }, 8, ["show"]), _hoisted_37], 64);
}